// extracted by mini-css-extract-plugin
export var aircallIframe = "_kb-3";
export var fabContainer = "_kb-5";
export var fabRinging = "_kb-6";
export var loadingOverlay = "_kb-4";
export var pulse = "_kb-7";
export var widgetContent = "_kb-2";
export var widgetPanel = "_kb-0";
export var widgetPanelExpanded = "_kb-1";